<!--
 * @Description: 
 * @Version: 1.0.0
 * @Date: 2022-04-11 10:16:14
 * @LastEditors: Yawen Yang
 * @LastEditTime: 2022-04-11 14:33:46
-->
<template>
  <div>
    <div ref="geetestCaptcha" class="captcha"></div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'GeetestCaptcha',
  data() {
    return {
      captchaInstance: null,
    }
  },
  props: {
    currentUrlName:{
      type: String,
      default:"login"
    },
    ResloveItem:
    {
      type: Object,
      default:function () {
        return {}
      }   
    }
  },
  computed: {
    langid() {
      return localStorage.getItem('currentLangId');
    },
    currentLang() {
      return localStorage.getItem('currentLang');
    }
  },
  mounted() {
    this.initGeetest();
  },
  methods: {    
    initGeetest() {
      var _this = this;
      if (typeof window !== 'undefined' && window.initGeetest4) {
        window.initGeetest4(
          {
            captchaId: "259184d0768b1c8405d1ac5b8aef74bc",
            language: this.langid=='936'?'zho':this.langid=='950'?'zho-tw':'eng',
            product: "bind",
            riskType: 'slide'
          },
          (captcha) => {
            captcha.onReady(function () {
              document.querySelector(".geetest_feedback").style.display="none";
              document.querySelector(".geetest_box_logo").style.display="none";
              
              // 判断是否为登录后的Contact Us场景（需要隐藏puzzle）
              // 通过检查页面路径来判断
              const isContactUsAfterLogin = window.location.pathname && 
                (window.location.pathname.includes('/UserSetting') || 
                 window.location.pathname.includes('/MyUsers'));
              
              const puzzleElements = document.querySelectorAll(".geetest_puzzle, .geetest_slice, .geetest_icon");
              puzzleElements.forEach(el => {
                if (el) {
                  if (isContactUsAfterLogin) {
                    // 登录后的Contact Us：隐藏puzzle
                    el.style.display = "none";
                  } else {
                    // 登录页面等其他场景：显示puzzle
                    el.style.display = "";
                  }
                }
              });
              
              console.log('[GeetestCaptcha] onReady - isContactUsAfterLogin:', isContactUsAfterLogin, 'pathname:', window.location.pathname);
             }).onSuccess(function () {
              return new Promise((resolve, reject) => {
                var data = captcha.getValidate();
                // 每次调用都使用新的回调函数
                _this.$nextTick(() => {
                  _this.$emit('captchaVerifyCallbackGeetest', data, (result) => {
                    // 立即 resolve Promise，避免闭包问题
                    resolve(result);
                  },_this.ResloveItem);
                });
              });
            }).onClose(function () {
              // 用户关闭拼图：通知业务页解除 loading，避免「继续」一直禁用
              _this.$emit('captchaClosed');
            }).onError(function () {
              
            }).onFail(function(failObj){
              if(failObj){
                //记录验证失败的日志
                let url = "https://web.adsaleinfo.com/vreg/PreregPFP/GeetestValidateLog?showcode=CPS22DB_Back&urlname="+_this.currentUrlName+"&captchaId="+failObj.captchaId+"&captchaType"+failObj.captchaType+"&failCount="+failObj.failCount+"&lotNumber="+failObj.lotNumber;
                axios.post(url);
              }
            })
            _this.captchaInstance = captcha;
          }
        );
      } else {
        console.log('Geetest SDK not found.');
      }
    },
    showGeetest() {
      if (this.captchaInstance != null) {
        this.captchaInstance.showCaptcha();
      } else {
        console.error('Geetest instance not initialized.');
      }
    }
  }
};

</script>

<style>
/* Add your styles here */

.geetest_box_wrap .geetest_slide .geetest_window .geetest_slice{
  z-index: 9999; /* fix missing puzzle in Apple device*/ 
}

/* 
 * Puzzle 拼图块的显示由 JavaScript 根据场景控制：
 * - 登录页面：显示 puzzle
 * - 登录后的 Contact Us：隐藏 puzzle
 */
</style>
